import * as React from "react";
function LgIcon() {
    return React.createElement("path", { d: "M8.69998 16.3442L7.65578 15.3L12.2058 10.75H8.25V9.25H14.75V15.75H13.25V11.7942L8.69998 16.3442ZM19 12V4.99998H12V3.5H20.5V12H19ZM5.3077 20.5C4.80257 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V3.5H4.99997V18.6923C4.99997 18.7692 5.03202 18.8397 5.09612 18.9038C5.16024 18.9679 5.23077 19 5.3077 19H20.5V20.5H5.3077Z", fill: "currentColor" });
}
export default LgIcon;
//# sourceMappingURL=Lg.js.map